var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDarkGreyDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.5 18.3",
    style: {
      enableBackground: "new 0 0 31.5 18.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#394351;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,0.5c-0.9-0.7-2.1-0.5-2.8,0.3l-9.4,11.8c-0.8,1-1.8,1.5-2.8,1.6v0c-1-0.1-2-0.7-2.8-1.6L3.6,0.8 C3,0,1.7-0.2,0.8,0.5C0,1.2-0.2,2.4,0.5,3.3l9.4,11.8c1.6,2,3.7,3.1,5.9,3.2v0c2.3-0.1,4.3-1.2,5.9-3.2L31,3.3 C31.7,2.4,31.6,1.2,30.7,0.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDarkGreyDown);
export default __webpack_public_path__ + "static/media/arrow_DarkGrey-down.4771e95c2e962522f538c8bcb304b8f3.svg";
export { ForwardRef as ReactComponent };